export default __webpack_public_path__ + "static/media/feature-image4.bb4de148.png";